import React, { Component } from "react";
import "../../Benefits/Benefits.css";
import { ToastContainer, toast } from "react-toastify";
import Select from "react-select";
import {
  main_url,
  validate,
  getActionStatus,
  getUserId,
  havePermission,
  getWorkFlowStatus,
  stopSaving,
  startSaving,
  isRequestedUser,
  alertText,
  getBranch,
  getWithdrawalLocation,
  getCookieData,
  fno,
} from "../../../utils/CommonFunction";
import ApprovalForm from "../../Common/ApprovalForm";
import DocumentList from "../../Common/DocumentList";
import moment from "moment";
import { getHeaders } from "../../../utils/apiHelper";
let form_validate = true;

class BenefitFuneralAddNew extends Component {
  constructor(props) {
    super(props);
    var user_info = getCookieData("user_info");
    this.state = {
      user_id: user_info.user_id,
      updatedBy: getUserId("user_info"),
      data: props.data,
      newDoc: [],
      doc: [],
      is_main_role: false,
      status_title: "",
      work_flow_status: {},
      comment: "",
      selected_location: [], //Added by STHA
      branch: [], //Added by STHA
      withdraw_location: props.data.withdraw_location
        ? props.data.withdraw_location
        : 0, //Added by STHA
    };
  }

  async componentDidMount() {
    this.getAllBranches(); //Added by STHA
    this.getEmployeeList();
    this.getDocument();
    this.getAvailableAmount();
    var work_flow = await getWorkFlowStatus(
      this.state.data.user_id,
      this.state.updatedBy,
      "External Training Benefit",
      "Benefit"
    );
    this.setState({
      work_flow_status: work_flow,
      is_main_role: havePermission(work_flow),
    });
  }

  //Added by STHA
  getAllBranches = async () => {
    const withdrawalLocations = await getWithdrawalLocation();

    let selected_location = this.getSelectedLocation(
      withdrawalLocations,
      this.state.data.withdraw_location
    );

    this.setState({
      branch: withdrawalLocations,
      selected_location: selected_location,
    });
  };

  //Added by STHA
  getSelectedLocation(branch, location) {
    let selected = branch.filter(function (b) {
      return b.value === location;
    });
    return selected;
  }

  //Added by STHA
  changeWithdrawLocation = (e) => {
    this.setState({
      selected_location: e,
      withdraw_location: e.value,
    });
  };

  getAvailableAmount() {
    fetch(
      `${main_url}external_benefit/getExternalAvailableAmount/${
        this.state.data.user_id
      }/${moment().format("YYYY")}`, {
        headers: getHeaders(),
      }
    )
      .then((res) => {
        if (res.ok) return res.json();
      })
      .then((list) => {
        this.setState({
          available_amount: list.amount,
        });
      });
  }

  getEmployeeList() {
    fetch(`${main_url}benefit/getEmployeeList`, {
      headers: getHeaders(),
    })
      .then((res) => {
        if (res.ok) return res.json();
      })
      .then((list) => {
        this.setState({
          employeeName: list,
        });
      });
  }

  getDocument() {
    fetch(
      main_url +
        "external_benefit/getDocument/" +
        this.props.data.external_training_id, {
        headers: getHeaders(),
      }
    )
      .then((response) => {
        if (response.ok) return response.json();
      })
      .then((res) => {
        if (res) {
          this.setState({
            doc: res,
          });
        }
      })
      .catch((error) => console.error(`Fetch Error =\n`, error));
  }

  approvalStatus = (text, comment) => {
    this.setState({ status_title: text, comment: comment }, () => this.edit());
  };

  edit() {
    if (
      validate("check_form") &&
      (this.state.newDoc.length > 0 || this.state.doc.length > 0)
    ) {
      var { status_title, is_main_role } = this.state;
      const formdata = new FormData();

      var obj = this.state.newDoc.length;
      for (var i = 0; i < obj; i++) {
        var imagedata = this.state.newDoc[i];

        formdata.append("uploadfile", imagedata);
      }
      // var data = this.state.data;
      var data = {
        training_date: this.state.data.training_date,
        training_period: this.state.data.training_period,
        request_amount: this.state.data.request_amount,
        training_purpose: this.state.data.training_purpose,
        training_name: this.state.data.training_name,
        available_amount: this.state.data.available_amount,
        approve_amount: this.state.data.approve_amount,
        status: this.state.data.status == 5 ? 0 : this.state.data.status,
        withdraw_location: this.state.withdraw_location, // Added by STHA
        form_no: this.state.data.form_no,
      };
      data.updatedBy = this.state.updatedBy;
      if (status_title !== "" && is_main_role) {
        var action = getActionStatus(
          status_title,
          this.state.data,
          this.state.updatedBy,
          this.state.comment
        );
        data.referback_by = action.referback_by;
        data.checked_by = action.checked_by;
        data.verified_by = action.verified_by;
        data.approved_by = action.approved_by;
        data.rejected_by = action.rejected_by;
        data.referback_date = action.referback_date;
        data.checked_date = action.checked_date;
        data.verified_date = action.verified_date;
        data.approved_date = action.approved_date;
        data.rejected_date = action.rejected_date;
        data.referback_comment = action.referback_comment;
        data.checked_comment = action.checked_comment;
        data.verified_comment = action.verified_comment;
        data.approved_comment = action.approved_comment;
        data.status = action.status;
      }
      formdata.append("benefit", JSON.stringify(this.state.data));
      formdata.append("data", JSON.stringify(data));
      formdata.append("oldDoc", JSON.stringify(this.state.doc));

      let status = 0;
      fetch(
        main_url +
          "external_benefit/edit/" +
          this.props.data.external_training_id,
        {
          method: "POST",
          headers: getHeaders(),
          body: formdata,
        }
      )
        .then((res) => {
          status = res.status;
          return res.text();
        })
        .then((text) => {
          if (status !== 200) {
            this.setState({
              status: this.state.status,
            });
          }
          this.props.showToast(status, text);
        });
    } else {
      startSaving();

      form_validate = false;
      toast.error(alertText, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  }
  removeOldDocument(index, event) {
    var array = this.state.doc;
    array.splice(index, 1);
    this.setState({
      doc: array,
    });
  }

  removeNewDocument(index, event) {
    var array = this.state.newDoc;
    array.splice(index, 1);
    this.setState({
      newDoc: array,
    });
  }

  handleEmployeeName = (event) => {
    this.setState({
      selected_employee: event,
      user_id: event.value,
    });
  };

  handleTrainingType = (event) => {
    let data = this.state.data;
    data.training_name = event.target.value;
    this.setState({
      data: data,
    });
  };

  handleAvailableAmount = (event) => {
    let data = this.state.data;
    data.available_amount = event.target.value;
    this.setState({
      data: data,
    });
  };

  handleTrainingDate = (event) => {
    let data = this.state.data;
    data.training_date = event.target.value;
    this.setState({
      data: data,
    });
  };

  handleAmount = (event) => {
    let data = this.state.data;
    data.request_amount = event.target.value;
    this.setState({
      data: data,
    });
  };

  handleApproveAmount = (event) => {
    let data = this.state.data;
    data.approve_amount = event.target.value;
    this.setState({
      data: data,
    });
  };

  handlePurpose = (event) => {
    let data = this.state.data;
    data.training_purpose = event.target.value;
    this.setState({
      data: data,
    });
  };

  handlePeriod = (event) => {
    let data = this.state.data;
    data.training_period = event.target.value;
    this.setState({
      data: data,
    });
  };

  checkFiles(e) {
    var files = e.target.files;
    var attachment = [];
    if (files.length > 2) {
      toast.warning("You can only upload a maximum of 2 files!");
    } else {
      for (let i = 0; i < files.length; i++) {
        attachment.push(files[i]);
      }
    }
    this.setState({
      newDoc: attachment,
    });
  }

  render() {
    return (
      <div className="benefits benefit-external-training">
        <ToastContainer />
        <div className="row">
          <form className="form-group" id="check_form">
            <div className="row">
              <div className="col-md-6">
                <div>
                  <label htmlFor="employee-name" className="col-sm-12">
                    Voucher No.
                  </label>
                </div>
                <div className="col-sm-10">
                  <input
                    className="form-control"
                    disabled
                    value={fno.fno_external + this.state.data.form_no}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div>
                  <label htmlFor="employee-name" className="col-sm-12">
                    Employee Name
                  </label>
                </div>
                <div className="col-sm-10">
                  <input
                    className="form-control"
                    options={this.state.employeeName}
                    disabled
                    value={this.state.data.fullname}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div>
                  <label htmlFor="date-of-training" className="col-sm-12">
                    Please Enter The Date of Training ?{" "}
                  </label>
                </div>
                <div className="col-sm-10">
                  <input
                    type="date"
                    className="form-control checkValidate"
                    placeholder="Provide The Date Of Training"
                    onChange={this.handleTrainingDate}
                    value={this.state.data.training_date}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div>
                  <label htmlFor="training-type" className="col-sm-12">
                    Please Enter The Training Type ?{" "}
                  </label>
                </div>
                <div className="col-sm-10">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="What is your training type"
                    onChange={this.handleTrainingType}
                    value={this.state.data.training_name}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div>
                  <label htmlFor="training-period" className="col-sm-12">
                    Please Enter The Training Period ?{" "}
                  </label>
                </div>
                <div className="col-sm-10">
                  <input
                    type="text"
                    className="form-control checkValidate"
                    placeholder="Enter The Training Period"
                    onChange={this.handlePeriod}
                    value={this.state.data.training_period}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div>
                  <label htmlFor="available-amount" className="col-sm-12">
                    Available Amount{" "}
                  </label>
                </div>
                <div className="col-sm-10">
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter The Available Amount"
                    onChange={this.handleAvailableAmount}
                    value={this.state.available_amount}
                    disabled
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div>
                  <label htmlFor="training-purpose" className="col-sm-12">
                    Please Enter The Training Purpose ?{" "}
                  </label>
                </div>
                <div className="col-sm-10">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter The Training Purpose"
                    onChange={this.handlePurpose}
                    value={this.state.data.training_purpose}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div>
                  <label htmlFor="amount" className="col-sm-12">
                    Please Enter The Request Amount ?{" "}
                  </label>
                </div>
                <div className="col-sm-10">
                  <input
                    type="number"
                    className="form-control checkValidate"
                    placeholder="Enter The Amount"
                    onChange={this.handleAmount}
                    value={this.state.data.request_amount}
                  />
                </div>
              </div>
            </div>
            {/* Added by STHA  */}
            <div className="row">
              <div className="col-md-6">
                <div>
                  <label className="col-sm-12">Withdrawal Location</label>
                </div>
                <div className="col-sm-10">
                  <Select
                    data-name="withdraw_loction"
                    value={this.state.selected_location}
                    onChange={this.changeWithdrawLocation}
                    options={this.state.branch}
                    className="react-select-container checkValidate"
                    classNamePrefix="react-select"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div>
                  <label htmlFor="training-purpose" className="col-sm-12">
                    Please Enter The Approve Amount ?{" "}
                  </label>
                </div>
                <div className="col-sm-10">
                  {this.state.data.user_id === this.state.updatedBy ? (
                    <>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter The Approve Amount"
                        onChange={this.handleApproveAmount}
                        value={this.state.data.approve_amount}
                        disabled
                      />
                    </>
                  ) : (
                    <>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter The Approve Amount"
                        onChange={this.handleApproveAmount}
                        value={this.state.data.approve_amount}
                      />
                    </>
                  )}
                </div>
              </div>
            </div>
            {/* Added by STHA  */}
            <div className="row">
              <div className="col-md-6">
                <div className="col-md-6">
                  <h4>Training Document</h4>
                </div>
                <div className="col-md-12">
                  <input
                    type="file"
                    id="dropExternalEdit"
                    className="dropZone"
                    onChange={this.checkFiles.bind(this)}
                    multiple
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12" style={{ overflowX: "auto" }}>
                <div className="ibox float-e-margins">
                  <div className="p-md col-md-12" style={{ float: "left" }}>
                    {this.state.doc.map((data, index) => (
                      <div className="fileuploader-items col-md-4">
                        <ul className="fileuploader-items-list">
                          <li className="fileuploader-item file-has-popup file-type-application file-ext-odt">
                            <div className="columns">
                              <div className="column-title">
                                <a
                                  href={`${main_url}external_benefit/getCRDocumentData/${data.name}`}
                                  download
                                  target="_blank"
                                  className="btn btn-primary document-body-bt document-width"
                                >
                                  {data.name.split("&@")[1]}
                                </a>
                              </div>
                              <div className="column-actions">
                                <a
                                  className="fileuploader-action fileuploader-action-remove"
                                  onClick={(event) =>
                                    this.removeOldDocument(index, event)
                                  }
                                >
                                  {" "}
                                  <i></i>
                                </a>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    ))}

                    {this.state.newDoc.map((data, index) => (
                      <div className="fileuploader-items col-md-4">
                        <ul className="fileuploader-items-list">
                          <li className="fileuploader-item file-has-popup file-type-application file-ext-odt">
                            <div className="columns">
                              <div className="column-title">
                                <a
                                  href="#"
                                  className="btn btn-primary document-body-bt document-width"
                                >
                                  {data.name}
                                </a>
                              </div>
                              <div className="column-actions">
                                <a
                                  className="fileuploader-action fileuploader-action-remove"
                                  onClick={(event) =>
                                    this.removeNewDocument(index, event)
                                  }
                                >
                                  {" "}
                                  <i></i>
                                </a>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div className="row save-btn">
          {havePermission(this.state.work_flow_status) &&
          this.state.data.user_id != this.state.user_id ? (
            <ApprovalForm
              approvalStatus={this.approvalStatus.bind(this)}
              status={this.state.data.status}
              work_flow={this.state.work_flow_status}
              total_amount={this.state.data.approve_amount}
            />
          ) : (
            <div className="col-md-12 btn-rightend">
              {this.state.data.status == undefined ||
              this.state.data.status == 5 ? (
                <div>
                  <button
                    onClick={this.edit.bind(this)}
                    className="btn btn-primary"
                    id="saving_button"
                    type="button"
                  >
                    Save
                  </button>
                </div>
              ) : (
                ""
              )}
              {/* <button onClick={this.edit.bind(this)} id="saving_button" 
                                className="btn btn-primary"><span>Save</span> </button> */}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default BenefitFuneralAddNew;
